import { render, staticRenderFns } from "./TemplateCriteriaQuestionForm.vue?vue&type=template&id=13523b4f"
import script from "./TemplateCriteriaQuestionForm.vue?vue&type=script&lang=js"
export * from "./TemplateCriteriaQuestionForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateCriteriaQuestionForm.vue?vue&type=style&index=0&id=13523b4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports